import { onSharingLinkDetected } from '../actions/publicActions';
import { addComposeLinkViewState } from 'owa-compose-link';
import { addSharingLink } from 'owa-link-data';
import { lazyIsOneDriveProRelatedLink, LinkProviderType } from 'owa-fileprovider-link';
import { orchestrator } from 'satcheljs';
import { lazyPrefetchWacResourcesForFiles } from 'owa-wac-prefetch-resources';

orchestrator(onSharingLinkDetected, actionMessage => {
    addSharingLink(
        actionMessage.linkId,
        actionMessage.linkUrl,
        actionMessage.sharingLinkIds,
        actionMessage.response,
        actionMessage.source,
        actionMessage.providerType,
        actionMessage.unwrappedUrl,
        actionMessage.creationDateTime
    );

    if (actionMessage.shouldAddComposeLinkViewState) {
        addComposeLinkViewState(actionMessage.linkId);
    }
});

orchestrator(onSharingLinkDetected, actionMessage => {
    if (actionMessage.response?.FileName) {
        tryPrefetchWacResourcesForFiles(
            actionMessage.response?.FileName,
            actionMessage.providerType
        );
    }
});

async function tryPrefetchWacResourcesForFiles(fileName: string, providerType: LinkProviderType) {
    const isOneDriveProRelatedLink = await lazyIsOneDriveProRelatedLink.import();
    if (isOneDriveProRelatedLink(providerType)) {
        lazyPrefetchWacResourcesForFiles.importAndExecute([fileName]);
    }
}
